import { render, staticRenderFns } from "./ValidationEmail.vue?vue&type=template&id=7b0d5952&scoped=true&"
import script from "./ValidationEmail.vue?vue&type=script&lang=js&"
export * from "./ValidationEmail.vue?vue&type=script&lang=js&"
import style0 from "./ValidationEmail.vue?vue&type=style&index=0&id=7b0d5952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0d5952",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VImg,VRow,VSpacer})
